export default "__VITE_ASSET__CqO1B_xR__"